import type { GridColDef } from '@mui/x-data-grid-pro';
import {
  FieldOption,
  type GetSaleLotsRow,
} from '@/components/publicSearch/constants';
import { formatLotPrice } from '@/lib/formatLotPrice';

const LOT_ASKING_PRICE_FIELD = 'ASKING_PRICE';

/** Price descriptions also carry results such as "Withdrawn" and "Passed In". */
export function saleLotPriceLabel(
  row: GetSaleLotsRow,
  kind: 'asking' | 'sale',
  currencySymbol: string,
): string {
  if (row.ID === -1) return '';
  return kind === 'asking'
    ? formatLotPrice(row.askingPrice, row.askingPriceDesc, currencySymbol)
    : formatLotPrice(row.salePrice, row.salePriceDesc, currencySymbol);
}

export function buildSaleLotPriceColumn(
  kind: 'asking' | 'sale',
  currencySymbol: string,
): GridColDef<GetSaleLotsRow> {
  return {
    field:
      kind === 'asking' ? LOT_ASKING_PRICE_FIELD : FieldOption.salePrice.value,
    headerName:
      kind === 'asking' ? 'Asking Price' : FieldOption.salePrice.label,
    filterable: false,
    sortable: false,
    width: 120,
    minWidth: 100,
    // Keep CSV/Excel/print consistent with the visible descriptive result.
    valueGetter: (_value, row) => saleLotPriceLabel(row, kind, currencySymbol),
    renderCell: ({ row }) => saleLotPriceLabel(row, kind, currencySymbol),
  };
}
